/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StepConstraintDto } from './StepConstraintDto';
import {
    StepConstraintDtoFromJSON,
    StepConstraintDtoFromJSONTyped,
    StepConstraintDtoToJSON,
    StepConstraintDtoToJSONTyped,
} from './StepConstraintDto';
import type { PossibleAnswerDto } from './PossibleAnswerDto';
import {
    PossibleAnswerDtoFromJSON,
    PossibleAnswerDtoFromJSONTyped,
    PossibleAnswerDtoToJSON,
    PossibleAnswerDtoToJSONTyped,
} from './PossibleAnswerDto';

/**
 * 
 * @export
 * @interface QuestionDto
 */
export interface QuestionDto {
    /**
     * Question unique identifier
     * @type {string}
     * @memberof QuestionDto
     */
    id: string;
    /**
     * Question key/code
     * @type {string}
     * @memberof QuestionDto
     */
    key: string;
    /**
     * Question label/text
     * @type {string}
     * @memberof QuestionDto
     */
    label: string;
    /**
     * Question type Id
     * @type {string}
     * @memberof QuestionDto
     */
    questionTypeId: string;
    /**
     * Question type code
     * @type {string}
     * @memberof QuestionDto
     */
    questionTypeCode: string;
    /**
     * Question type label
     * @type {string}
     * @memberof QuestionDto
     */
    questionTypeLabel: string;
    /**
     * Step number in the questionnaire
     * @type {number}
     * @memberof QuestionDto
     */
    step: number | null;
    /**
     * Display order of the question
     * @type {number}
     * @memberof QuestionDto
     */
    displayOrder: number;
    /**
     * Icon key for the question
     * @type {string}
     * @memberof QuestionDto
     */
    iconKey?: string | null;
    /**
     * Group title for question grouping
     * @type {string}
     * @memberof QuestionDto
     */
    groupTitle?: string | null;
    /**
     * Whether the question is required
     * @type {boolean}
     * @memberof QuestionDto
     */
    isRequired: boolean;
    /**
     * Pre-filled answer when the question has no saved answer yet: "true"/"false" for a boolean question, the possible answer key for a choice question. Null = no default.
     * @type {string}
     * @memberof QuestionDto
     */
    defaultValue?: string | null;
    /**
     * Dependencies for this question
     * @type {Array<StepConstraintDto>}
     * @memberof QuestionDto
     */
    dependsOn: Array<StepConstraintDto>;
    /**
     * Constraints applied to this question
     * @type {Array<StepConstraintDto>}
     * @memberof QuestionDto
     */
    constraints: Array<StepConstraintDto>;
    /**
     * Conditions to ignore this question
     * @type {Array<StepConstraintDto>}
     * @memberof QuestionDto
     */
    skipIf: Array<StepConstraintDto>;
    /**
     * Possible answers for the question
     * @type {Array<PossibleAnswerDto>}
     * @memberof QuestionDto
     */
    possibleAnswers: Array<PossibleAnswerDto>;
}

/**
 * Check if a given object implements the QuestionDto interface.
 */
export function instanceOfQuestionDto(value: object): value is QuestionDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('questionTypeId' in value) || value['questionTypeId'] === undefined) return false;
    if (!('questionTypeCode' in value) || value['questionTypeCode'] === undefined) return false;
    if (!('questionTypeLabel' in value) || value['questionTypeLabel'] === undefined) return false;
    if (!('step' in value) || value['step'] === undefined) return false;
    if (!('displayOrder' in value) || value['displayOrder'] === undefined) return false;
    if (!('isRequired' in value) || value['isRequired'] === undefined) return false;
    if (!('dependsOn' in value) || value['dependsOn'] === undefined) return false;
    if (!('constraints' in value) || value['constraints'] === undefined) return false;
    if (!('skipIf' in value) || value['skipIf'] === undefined) return false;
    if (!('possibleAnswers' in value) || value['possibleAnswers'] === undefined) return false;
    return true;
}

export function QuestionDtoFromJSON(json: any): QuestionDto {
    return QuestionDtoFromJSONTyped(json, false);
}

export function QuestionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'key': json['key'],
        'label': json['label'],
        'questionTypeId': json['questionTypeId'],
        'questionTypeCode': json['questionTypeCode'],
        'questionTypeLabel': json['questionTypeLabel'],
        'step': json['step'],
        'displayOrder': json['displayOrder'],
        'iconKey': json['iconKey'] == null ? undefined : json['iconKey'],
        'groupTitle': json['groupTitle'] == null ? undefined : json['groupTitle'],
        'isRequired': json['isRequired'],
        'defaultValue': json['defaultValue'] == null ? undefined : json['defaultValue'],
        'dependsOn': ((json['dependsOn'] as Array<any>).map(StepConstraintDtoFromJSON)),
        'constraints': ((json['constraints'] as Array<any>).map(StepConstraintDtoFromJSON)),
        'skipIf': ((json['skipIf'] as Array<any>).map(StepConstraintDtoFromJSON)),
        'possibleAnswers': ((json['possibleAnswers'] as Array<any>).map(PossibleAnswerDtoFromJSON)),
    };
}

export function QuestionDtoToJSON(json: any): QuestionDto {
    return QuestionDtoToJSONTyped(json, false);
}

export function QuestionDtoToJSONTyped(value?: QuestionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'key': value['key'],
        'label': value['label'],
        'questionTypeId': value['questionTypeId'],
        'questionTypeCode': value['questionTypeCode'],
        'questionTypeLabel': value['questionTypeLabel'],
        'step': value['step'],
        'displayOrder': value['displayOrder'],
        'iconKey': value['iconKey'],
        'groupTitle': value['groupTitle'],
        'isRequired': value['isRequired'],
        'defaultValue': value['defaultValue'],
        'dependsOn': ((value['dependsOn'] as Array<any>).map(StepConstraintDtoToJSON)),
        'constraints': ((value['constraints'] as Array<any>).map(StepConstraintDtoToJSON)),
        'skipIf': ((value['skipIf'] as Array<any>).map(StepConstraintDtoToJSON)),
        'possibleAnswers': ((value['possibleAnswers'] as Array<any>).map(PossibleAnswerDtoToJSON)),
    };
}

